import axios from "axios";
import { useURL } from "../data/Config";
import { IPost } from "../types";

export interface IPostCount {
  totalPosts: number;
  weeklyPosts: {
    name: string;
    job: number;
    project: number;
  }[];
}

export const getPostCount = async (): Promise<IPostCount> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(`${useURL}/posts/admin/count`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getAllPostsByAdmin = async (
  searchQuery?: string
): Promise<{ jobs: IPost[]; projects: IPost[] }> => {
  const token = localStorage.getItem("AUTH_TOKEN");

  const response = await axios.get(`${useURL}/posts/admin/get-all-posts`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      searchQuery,
    },
  });

  return {
    jobs: response.data.jobs || [],
    projects: response.data.projects || [],
  };
};
